import workflowServices from '../../../../../../services/work-flow'
import recallServices from '../../../../../../services/supplier/supplier-recall'
import store from '../../../../../../store'
import moment from 'moment'
export default {
    components: {
    },
    data() {
        return {
            title: '',
            formType: '',
            item: [],
            communicationId: null,
            orgType: store.state.userType,
            providerCommunicationId: null,
            communicationType: '',
            selectedSendNotification: 'REMINDER_EMAIL',
            providerList: [],
            availableStatuses: [],
            selectedReminderStatus: null
        }
    },

    computed: {
        selectedProviderDetails() {
            // Map selected providers to include their full details
            if (!Array.isArray(this.item) || this.item.length === 0) {
                return []
            }
            return this.item.map(selection => {
                const provider = this.providerList.find(p =>
                    p.provider_id === selection.providerId &&
                    p.recallsiteid === selection.recallSiteId
                )
                if (provider) {
                    return {
                        name: provider.name,
                        location: provider.location_name || `Site #${selection.recallSiteId}`,
                        status: provider.status
                    }
                }
                return {
                    name: `Provider #${selection.providerId}`,
                    location: `Site #${selection.recallSiteId}`,
                    status: 'Unknown'
                }
            })
        },
        statusSendOptions() {
            // Generate options based on provider status counts using the same logic as the template
            // If acknowledge_datetime doesn't exist: "Not Acknowledged"
            // If acknowledge_datetime exists and status is 'OPEN': "In Progress"
            // If acknowledge_datetime exists and status is 'COMPLETED': "Completed"
            const notAcknowledged = this.providerList.filter(p => !p.acknowledge_datetime).length
            const inProgress = this.providerList.filter(p => p.acknowledge_datetime && p.status === 'OPEN').length
            const allProviders = this.providerList.filter(p => !p.acknowledge_datetime || p.status === 'OPEN').length

            return [
                {
                    text: `All Providers (${allProviders})`,
                    value: 'REMINDER_EMAIL',
                    disabled: !(allProviders > 0)
                },
                {
                    text: `Not-acknowledged Providers (${notAcknowledged})`,
                    value: 'REMINDER_NON_ACKNOWLEDGED_PROVIDERS',
                    disabled: !(notAcknowledged > 0)
                },
                {
                    text: `In-progress Providers (${inProgress})`,
                    value: 'REMINDER_IN_PROGRESS',
                    disabled: !(inProgress > 0)
                }
            ]
        }
    },

    methods: {
        forceRerenderView(item, communicationId, type, providerCommunicationId, communicationType, providerList = [], availableStatuses = []) {
            this.communicationId = communicationId
            this.providerCommunicationId = providerCommunicationId
            this.item = item
            this.communicationType = communicationType
            this.providerList = providerList
            this.availableStatuses = availableStatuses
            this.selectedReminderStatus = null
            this.title = 'Send Reminder to:'
            this.formType = type
            console.log('[ReminderModal] forceRerenderView called', {
                type,
                itemCount: Array.isArray(item) ? item.length : 0,
                providerListCount: providerList.length,
                availableStatuses
            })
            this.$refs.modal.show()
        },
        cancel() {
            this.$refs.modal.hide()
        },
        save()
        {
            console.log('[ReminderModal] Save button clicked | FormType:', this.formType)
            let selectedProviders = []
            let selectedReminderStatuses = null
            if (this.formType === 'Status') {
                // For Status mode, use the selected status
                if (!this.selectedReminderStatus) {
                    console.warn('[ReminderModal] No status selected')
                    this._showToast('Please select a status.', 'warning')
                    return
                }
                selectedReminderStatuses = this.selectedReminderStatus
                console.log('[ReminderModal] Status mode - Selected status:', selectedReminderStatuses)
            } else {
                console.log('[ReminderModal] SendMail mode - No provider/status filtering')
            }

            console.log('[ReminderModal] Calling API with payload:', {
                communicationId: this.communicationId,
                sendType: this.selectedSendNotification,
                communicationType: this.communicationType,
                selectedProviders: selectedProviders,
                selectedReminderStatuses: selectedReminderStatuses
            })
            recallServices.sendNotification(
                this.communicationId,
                this.selectedSendNotification,
                this.communicationType,
                null,
                null,
                null,
                selectedProviders,
                selectedReminderStatuses
            ).then(resp => {
                if (!resp.error) {
                    console.log('[ReminderModal] Email sent successfully')
                    this._showToast('Email sent successfully!')
                    this.$refs.modal.hide()
                    this.$emit('onCompleted')
                } else {
                    console.error('[ReminderModal] Failed to send email:', resp.error)
                }
            })
        }
    }

}